import { render, staticRenderFns } from "./istarshine.vue?vue&type=template&id=6600c37f"
import script from "./istarshine.vue?vue&type=script&lang=js"
export * from "./istarshine.vue?vue&type=script&lang=js"
import style0 from "./istarshine.vue?vue&type=style&index=0&id=6600c37f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports